<div *ngIf="!favBooks">
  <app-loading-spinner></app-loading-spinner>
</div>

<div *ngIf="favBooks">
  <app-navbar></app-navbar>
  <div class="container section-top ">
    <h1>{{ title }}!</h1>
    <div class="row">
      <div *ngFor="let book of favBooks" class="col-sm-6 col-md-4  p-2">
        <mdb-card class="card">
          <div class="view rgba-white-slight waves-light" mdbWavesEffect>
            <img class="card-img" [src]="book.image" alt="Card image cap" />
            <a [routerLink]="['book', book.id]">
              <div class="mask"></div>
            </a>
          </div>
          <mdb-card-body>
            <mdb-card-title>
              <h4>{{ book.title }}</h4>
            </mdb-card-title>

            <mdb-card-text>
              {{ book.description }}
            </mdb-card-text>

            <h4 class="border">Book rate : {{ book.rate }}</h4>
          </mdb-card-body>
        </mdb-card>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
